import { render, staticRenderFns } from "./Subventionsbeitragliste.vue?vue&type=template&id=0cb45348"
import script from "./Subventionsbeitragliste.vue?vue&type=script&lang=js"
export * from "./Subventionsbeitragliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports